export * from './life-categories'
